import { render, staticRenderFns } from "./AdminCalendarEvents.vue?vue&type=template&id=15026c4c&"
import script from "./AdminCalendarEvents.vue?vue&type=script&lang=js&"
export * from "./AdminCalendarEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports